<p-dialog
  header="お話を聞きたい"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [(visible)]="isShow"
  styleClass="dialog"
>

  <div class="p-col-12 text-group p-d-flex p-jc-center p-text-bold">
    <div class="p-col-10">
      <span class="p-m-0">
        <h4 class="p-m-0 text-large p-text-center">
          相手に『【{{ organizationName }}】』を含む話を聞きたい旨のメールが送信されます。
        </h4>
        <p class="tier p-text-center">
          よろしければOKを押してください。
        </p>
      </span>
    </div>
  </div>

  <p-footer>
    <div class="button-group p-d-flex p-jc-center">
      <button
        pButton
        type="button"
        label="OK"
        class="button-accept mr-4"
        (click)="confirm()"
        ></button>
      <button
        pButton
        type="button"
        label="キャンセル"
        class="button-cancel"
        (click)="closeDialog()"
      ></button>
    </div>
  </p-footer>
</p-dialog>
